export interface Film {
  id: string;
  title: string;
  year: number;
  type: "movie" | "tv" | "short";
  region: string;
  director: string;
  cast: string[];
  genres: string[];
  synopsis: string;
  poster: string;
  rating: number;
  popularity: number;
  updatedAt: string;
  releaseDate: string;
  runtime: string;
}

export const films: Film[] = [
  {
    id: "silent-tide",
    title: "静默的潮汐",
    year: 2023,
    type: "movie",
    region: "中国大陆",
    director: "陈砚舟",
    cast: ["林知遥", "周慕川", "宋晚"],
    genres: ["家庭", "剧情", "文艺"],
    synopsis:
      "一场突如其来的家庭变故，让分隔多年的三兄妹被迫回到海边的老屋。在整理母亲遗物的过程中，被时间掩埋的秘密逐渐浮出水面。他们不得不重新审视血缘、责任与原谅的边界，在沉默的潮汐里寻找彼此和解的可能。",
    poster:
      "https://readdy.ai/api/search-image?query=Serious%20artistic%20movie%20poster%20of%20a%20lone%20figure%20standing%20by%20a%20desolate%20seaside%20at%20dusk%2C%20muted%20deep%20blue%20and%20grey%20tones%20with%20a%20hint%20of%20dark%20red%2C%20cinematic%20dramatic%20lighting%2C%20melancholic%20mood%2C%20minimal%20composition%2C%20no%20text%2C%20high%20detail%20editorial%20photography&width=600&height=900&seq=ethics-poster-01&orientation=portrait",
    rating: 8.6,
    popularity: 96,
    updatedAt: "2024-09-12",
    releaseDate: "2023-05-18",
    runtime: "127分钟",
  },
  {
    id: "half-light-marriage",
    title: "半光之年",
    year: 2024,
    type: "tv",
    region: "中国大陆",
    director: "许承梧",
    cast: ["顾清欢", "沈亦白", "梁叙"],
    genres: ["婚姻", "都市", "情感"],
    synopsis:
      "一对在外人眼中令人称羡的夫妻，在婚姻进入第十个年头后，开始面对信任的裂痕与生活的疲惫。剧集以细腻的笔触描绘都市男女在亲密关系里的挣扎与选择，探讨忠诚、自我与共同成长的真义。",
    poster:
      "https://readdy.ai/api/search-image?query=Serious%20artistic%20TV%20drama%20poster%20of%20a%20couple%20standing%20apart%20in%20a%20dim%20modern%20apartment%2C%20muted%20deep%20blue%20and%20grey%20tones%20with%20a%20hint%20of%20dark%20red%2C%20cinematic%20dramatic%20lighting%2C%20emotional%20tension%2C%20minimal%20composition%2C%20no%20text%2C%20high%20detail%20editorial%20photography&width=600&height=900&seq=ethics-poster-02&orientation=portrait",
    rating: 8.9,
    popularity: 99,
    updatedAt: "2024-10-02",
    releaseDate: "2024-03-08",
    runtime: "共24集",
  },
  {
    id: "borrowed-name",
    title: "借来的名字",
    year: 2022,
    type: "movie",
    region: "中国香港",
    director: "高见山",
    cast: ["何敬文", "麦芷晴", "苏世安"],
    genres: ["悬疑", "剧情", "社会"],
    synopsis:
      "一名普通职员意外发现自己的身份被人冒用多年，追查真相的过程中，他被迫直面自己曾经逃避的过往。影片在悬疑的外壳下，探讨身份认同与道德代价的沉重命题。",
    poster:
      "https://readdy.ai/api/search-image?query=Serious%20artistic%20thriller%20movie%20poster%20of%20a%20solitary%20man%20seen%20through%20a%20rain-streaked%20window%20at%20night%2C%20muted%20deep%20blue%20and%20grey%20tones%20with%20a%20hint%20of%20dark%20red%2C%20cinematic%20dramatic%20lighting%2C%20tense%20mood%2C%20minimal%20composition%2C%20no%20text%2C%20high%20detail%20editorial%20photography&width=600&height=900&seq=ethics-poster-03&orientation=portrait",
    rating: 7.9,
    popularity: 82,
    updatedAt: "2024-08-21",
    releaseDate: "2022-11-25",
    runtime: "114分钟",
  },
  {
    id: "the-long-letter",
    title: "长信",
    year: 2024,
    type: "short",
    region: "中国台湾",
    director: "郑柏舟",
    cast: ["许亦柔", "江书宁"],
    genres: ["文艺", "情感", "家庭"],
    synopsis:
      "一封迟到了二十年的信，把两个早已形同陌路的人重新联系在一起。短片以极简的场景和克制的对白，讲述关于亏欠、记忆与释怀的温柔故事。",
    poster:
      "https://readdy.ai/api/search-image?query=Serious%20artistic%20short%20film%20poster%20of%20hands%20holding%20an%20old%20folded%20letter%20near%20a%20lamp%2C%20muted%20deep%20blue%20and%20grey%20tones%20with%20a%20hint%20of%20dark%20red%2C%20intimate%20cinematic%20lighting%2C%20nostalgic%20mood%2C%20minimal%20composition%2C%20no%20text%2C%20high%20detail%20editorial%20photography&width=600&height=900&seq=ethics-poster-04&orientation=portrait",
    rating: 8.3,
    popularity: 74,
    updatedAt: "2024-09-28",
    releaseDate: "2024-06-14",
    runtime: "32分钟",
  },
  {
    id: "quiet-river",
    title: "静水之下",
    year: 2023,
    type: "movie",
    region: "中国大陆",
    director: "陈砚舟",
    cast: ["周慕川", "沈亦白", "柳未眠"],
    genres: ["社会", "剧情", "犯罪"],
    synopsis:
      "小镇上一桩看似普通的纠纷，牵出了一个家庭隐藏多年的裂痕。记者出身的导演用近乎纪录片的镜头语言，呈现普通人在利益与良知之间的艰难抉择。",
    poster:
      "https://readdy.ai/api/search-image?query=Serious%20artistic%20social%20drama%20movie%20poster%20of%20a%20still%20dark%20river%20with%20faint%20distant%20lights%2C%20muted%20deep%20blue%20and%20grey%20tones%20with%20a%20hint%20of%20dark%20red%2C%20cinematic%20dramatic%20lighting%2C%20somber%20mood%2C%20minimal%20composition%2C%20no%20text%2C%20high%20detail%20editorial%20photography&width=600&height=900&seq=ethics-poster-05&orientation=portrait",
    rating: 8.1,
    popularity: 88,
    updatedAt: "2024-07-30",
    releaseDate: "2023-09-01",
    runtime: "131分钟",
  },
  {
    id: "two-winters",
    title: "两个冬天",
    year: 2022,
    type: "tv",
    region: "韩国",
    director: "朴叙延",
    cast: ["金秀妍", "李道河", "崔敏贞"],
    genres: ["情感", "家庭", "都市"],
    synopsis:
      "两个在冬天相遇又分开的人，在十年后的一次偶然重逢中，重新面对当年未能说出口的真心。剧集以四季为章节，慢慢揭开一段被时间冲刷却未曾消失的感情。",
    poster:
      "https://readdy.ai/api/search-image?query=Serious%20artistic%20romantic%20drama%20poster%20of%20two%20figures%20walking%20apart%20in%20soft%20falling%20snow%2C%20muted%20deep%20blue%20and%20grey%20tones%20with%20a%20hint%20of%20dark%20red%2C%20cinematic%20dramatic%20lighting%2C%20wistful%20mood%2C%20minimal%20composition%2C%20no%20text%2C%20high%20detail%20editorial%20photography&width=600&height=900&seq=ethics-poster-06&orientation=portrait",
    rating: 8.5,
    popularity: 91,
    updatedAt: "2024-06-18",
    releaseDate: "2022-12-05",
    runtime: "共16集",
  },
  {
    id: "the-inheritance",
    title: "继承者之言",
    year: 2024,
    type: "movie",
    region: "中国大陆",
    director: "许承梧",
    cast: ["梁叙", "顾清欢", "何敬文"],
    genres: ["家庭", "剧情", "商战"],
    synopsis:
      "一家老字号企业面临传承危机，三个子女各有算盘。当父亲的遗嘱揭开一个意外条款，家族内部的信任与野心同时被推向极限。影片探讨财富之外，真正值得继承的东西。",
    poster:
      "https://readdy.ai/api/search-image?query=Serious%20artistic%20family%20drama%20movie%20poster%20of%20an%20empty%20formal%20dining%20room%20with%20a%20single%20lit%20lamp%2C%20muted%20deep%20blue%20and%20grey%20tones%20with%20a%20hint%20of%20dark%20red%2C%20cinematic%20dramatic%20lighting%2C%20austere%20mood%2C%20minimal%20composition%2C%20no%20text%2C%20high%20detail%20editorial%20photography&width=600&height=900&seq=ethics-poster-07&orientation=portrait",
    rating: 8.2,
    popularity: 90,
    updatedAt: "2024-09-05",
    releaseDate: "2024-01-19",
    runtime: "122分钟",
  },
  {
    id: "crossing-fog",
    title: "穿雾而过",
    year: 2023,
    type: "movie",
    region: "日本",
    director: "中村理沙",
    cast: ["藤井遥", "佐仓真", "绪方彻"],
    genres: ["文艺", "剧情", "社会"],
    synopsis:
      "一位中年教师在退休前最后一次家访，意外走进了学生家庭深藏的困境。她开始反思自己数十年教学生涯中那些被忽略的瞬间，以及教育真正的意义。",
    poster:
      "https://readdy.ai/api/search-image?query=Serious%20artistic%20literary%20film%20poster%20of%20a%20lone%20woman%20walking%20through%20thick%20morning%20fog%20along%20a%20narrow%20path%2C%20muted%20deep%20blue%20and%20grey%20tones%20with%20a%20hint%20of%20dark%20red%2C%20cinematic%20dramatic%20lighting%2C%20contemplative%20mood%2C%20minimal%20composition%2C%20no%20text%2C%20high%20detail%20editorial%20photography&width=600&height=900&seq=ethics-poster-08&orientation=portrait",
    rating: 8.0,
    popularity: 77,
    updatedAt: "2024-05-22",
    releaseDate: "2023-10-20",
    runtime: "118分钟",
  },
  {
    id: "the-last-guest",
    title: "最后的访客",
    year: 2024,
    type: "short",
    region: "中国大陆",
    director: "郑柏舟",
    cast: ["宋晚", "苏世安"],
    genres: ["悬疑", "情感", "文艺"],
    synopsis:
      "深夜的旧公寓里，一位不速之客的到来打破了一个人的平静。两人之间一场看似平淡的对话，逐渐揭开了彼此都试图遗忘的往事。",
    poster:
      "https://readdy.ai/api/search-image?query=Serious%20artistic%20short%20film%20poster%20of%20a%20silhouette%20standing%20in%20a%20doorway%20lit%20from%20behind%2C%20muted%20deep%20blue%20and%20grey%20tones%20with%20a%20hint%20of%20dark%20red%2C%20cinematic%20dramatic%20lighting%2C%20tense%20mood%2C%20minimal%20composition%2C%20no%20text%2C%20high%20detail%20editorial%20photography&width=600&height=900&seq=ethics-poster-09&orientation=portrait",
    rating: 7.8,
    popularity: 68,
    updatedAt: "2024-10-08",
    releaseDate: "2024-08-02",
    runtime: "28分钟",
  },
  {
    id: "mothers-choice",
    title: "母亲的选择",
    year: 2021,
    type: "tv",
    region: "中国大陆",
    director: "叶南乔",
    cast: ["柳未眠", "麦芷晴", "江书宁"],
    genres: ["家庭", "情感", "社会"],
    synopsis:
      "一位母亲在事业与孩子之间反复权衡，她的每一个决定都牵动着整个家庭。剧集真实呈现当代女性在多重身份下的困境与坚韧，引发广泛共鸣。",
    poster:
      "https://readdy.ai/api/search-image?query=Serious%20artistic%20family%20drama%20poster%20of%20a%20woman%20holding%20a%20sleeping%20child%20by%20a%20window%20at%20dawn%2C%20muted%20deep%20blue%20and%20grey%20tones%20with%20a%20hint%20of%20dark%20red%2C%20cinematic%20dramatic%20lighting%2C%20tender%20mood%2C%20minimal%20composition%2C%20no%20text%2C%20high%20detail%20editorial%20photography&width=600&height=900&seq=ethics-poster-10&orientation=portrait",
    rating: 8.4,
    popularity: 85,
    updatedAt: "2024-04-11",
    releaseDate: "2021-07-16",
    runtime: "共30集",
  },
  {
    id: "wrong-turn",
    title: "歧路",
    year: 2023,
    type: "movie",
    region: "中国香港",
    director: "高见山",
    cast: ["何敬文", "崔敏贞", "沈亦白"],
    genres: ["犯罪", "剧情", "悬疑"],
    synopsis:
      "一次看似微不足道的谎言，把一个普通人推向了无法回头的歧路。影片以冷静的叙事节奏，探讨人性在压力下的脆弱与救赎的代价。",
    poster:
      "https://readdy.ai/api/search-image?query=Serious%20artistic%20crime%20drama%20movie%20poster%20of%20a%20man%20at%20a%20rainy%20city%20crossroads%20at%20night%2C%20muted%20deep%20blue%20and%20grey%20tones%20with%20a%20hint%20of%20dark%20red%2C%20cinematic%20dramatic%20lighting%2C%20brooding%20mood%2C%20minimal%20composition%2C%20no%20text%2C%20high%20detail%20editorial%20photography&width=600&height=900&seq=ethics-poster-11&orientation=portrait",
    rating: 7.7,
    popularity: 79,
    updatedAt: "2024-06-02",
    releaseDate: "2023-04-14",
    runtime: "116分钟",
  },
  {
    id: "still-water-years",
    title: "岁月静流",
    year: 2022,
    type: "movie",
    region: "中国台湾",
    director: "郑柏舟",
    cast: ["许亦柔", "林知遥"],
    genres: ["文艺", "家庭", "情感"],
    synopsis:
      "一对母女在乡下老宅度过的一个夏天，让多年来积压的误解慢慢融解。影片用安静的镜头记录日常的细微变化，讲述时间如何温柔地修复人心。",
    poster:
      "https://readdy.ai/api/search-image?query=Serious%20artistic%20literary%20film%20poster%20of%20a%20quiet%20countryside%20house%20at%20golden%20dusk%2C%20muted%20deep%20blue%20and%20grey%20tones%20with%20a%20hint%20of%20dark%20red%2C%20cinematic%20dramatic%20lighting%2C%20serene%20mood%2C%20minimal%20composition%2C%20no%20text%2C%20high%20detail%20editorial%20photography&width=600&height=900&seq=ethics-poster-12&orientation=portrait",
    rating: 8.2,
    popularity: 72,
    updatedAt: "2024-03-15",
    releaseDate: "2022-08-26",
    runtime: "109分钟",
  },
  {
    id: "the-debt",
    title: "欠",
    year: 2024,
    type: "short",
    region: "中国大陆",
    director: "叶南乔",
    cast: ["梁叙", "宋晚"],
    genres: ["社会", "剧情", "犯罪"],
    synopsis:
      "一笔拖了三年的借款，成为两个旧友之间无法跨越的墙。短片直击人情社会里的信用与情义，在短短的篇幅中呈现人性的复杂。",
    poster:
      "https://readdy.ai/api/search-image?query=Serious%20artistic%20short%20film%20poster%20of%20an%20empty%20worn%20desk%20with%20a%20single%20banknote%20under%20a%20cold%20light%2C%20muted%20deep%20blue%20and%20grey%20tones%20with%20a%20hint%20of%20dark%20red%2C%20cinematic%20dramatic%20lighting%2C%20gritty%20mood%2C%20minimal%20composition%2C%20no%20text%2C%20high%20detail%20editorial%20photography&width=600&height=900&seq=ethics-poster-13&orientation=portrait",
    rating: 7.6,
    popularity: 64,
    updatedAt: "2024-09-19",
    releaseDate: "2024-05-10",
    runtime: "25分钟",
  },
  {
    id: "echoes-of-home",
    title: "家的回声",
    year: 2023,
    type: "tv",
    region: "中国大陆",
    director: "陈砚舟",
    cast: ["顾清欢", "周慕川", "柳未眠"],
    genres: ["家庭", "都市", "情感"],
    synopsis:
      "一个三代同堂的家庭，在老宅即将拆迁的消息传来后，被迫重新面对彼此的关系。剧集以家为轴，串联起每个人物各自的困境与成长。",
    poster:
      "https://readdy.ai/api/search-image?query=Serious%20artistic%20family%20drama%20poster%20of%20an%20old%20traditional%20courtyard%20house%20at%20twilight%2C%20muted%20deep%20blue%20and%20grey%20tones%20with%20a%20hint%20of%20dark%20red%2C%20cinematic%20dramatic%20lighting%2C%20nostalgic%20mood%2C%20minimal%20composition%2C%20no%20text%2C%20high%20detail%20editorial%20photography&width=600&height=900&seq=ethics-poster-14&orientation=portrait",
    rating: 8.7,
    popularity: 94,
    updatedAt: "2024-08-14",
    releaseDate: "2023-11-03",
    runtime: "共36集",
  },
  {
    id: "the-witness",
    title: "旁观者",
    year: 2022,
    type: "movie",
    region: "韩国",
    director: "朴叙延",
    cast: ["金秀妍", "佐仓真", "崔敏贞"],
    genres: ["悬疑", "社会", "剧情"],
    synopsis:
      "一位目睹了不公却选择沉默的邻居，在良知的煎熬中做出改变。影片质问：当每个人都只是旁观者，正义由谁来守护。",
    poster:
      "https://readdy.ai/api/search-image?query=Serious%20artistic%20social%20thriller%20poster%20of%20a%20figure%20watching%20from%20a%20dark%20apartment%20window%20at%20night%2C%20muted%20deep%20blue%20and%20grey%20tones%20with%20a%20hint%20of%20dark%20red%2C%20cinematic%20dramatic%20lighting%2C%20uneasy%20mood%2C%20minimal%20composition%2C%20no%20text%2C%20high%20detail%20editorial%20photography&width=600&height=900&seq=ethics-poster-15&orientation=portrait",
    rating: 8.3,
    popularity: 83,
    updatedAt: "2024-02-27",
    releaseDate: "2022-06-17",
    runtime: "124分钟",
  },
  {
    id: "winter-promise",
    title: "冬日的约定",
    year: 2024,
    type: "movie",
    region: "日本",
    director: "中村理沙",
    cast: ["藤井遥", "绪方彻", "许亦柔"],
    genres: ["情感", "文艺", "家庭"],
    synopsis:
      "一对父女约定每年冬天见一面，直到某个冬天父亲再也没有出现。多年后女儿循着旧日线索，重新拼凑起那段温柔的时光与未完成的告别。",
    poster:
      "https://readdy.ai/api/search-image?query=Serious%20artistic%20emotional%20film%20poster%20of%20a%20snowy%20quiet%20street%20with%20warm%20window%20lights%2C%20muted%20deep%20blue%20and%20grey%20tones%20with%20a%20hint%20of%20dark%20red%2C%20cinematic%20dramatic%20lighting%2C%20tender%20mood%2C%20minimal%20composition%2C%20no%20text%2C%20high%20detail%20editorial%20photography&width=600&height=900&seq=ethics-poster-16&orientation=portrait",
    rating: 8.6,
    popularity: 89,
    updatedAt: "2024-10-10",
    releaseDate: "2024-02-09",
    runtime: "120分钟",
  },
  {
    id: "the-mirror-room",
    title: "镜中房间",
    year: 2023,
    type: "short",
    region: "中国香港",
    director: "高见山",
    cast: ["麦芷晴", "苏世安"],
    genres: ["悬疑", "文艺", "剧情"],
    synopsis:
      "一个女人搬进一间满是镜子的房间后，开始分不清哪些是回忆、哪些是幻觉。短片以实验性的影像语言，探讨自我认知与真实的关系。",
    poster:
      "https://readdy.ai/api/search-image?query=Serious%20artistic%20experimental%20short%20film%20poster%20of%20a%20woman%20reflected%20in%20multiple%20mirrors%20in%20a%20dim%20room%2C%20muted%20deep%20blue%20and%20grey%20tones%20with%20a%20hint%20of%20dark%20red%2C%20cinematic%20dramatic%20lighting%2C%20dreamlike%20mood%2C%20minimal%20composition%2C%20no%20text%2C%20high%20detail%20editorial%20photography&width=600&height=900&seq=ethics-poster-17&orientation=portrait",
    rating: 7.5,
    popularity: 61,
    updatedAt: "2024-07-08",
    releaseDate: "2023-12-01",
    runtime: "22分钟",
  },
  {
    id: "the-tide-returns",
    title: "潮汐再临",
    year: 2024,
    type: "tv",
    region: "中国大陆",
    director: "叶南乔",
    cast: ["宋晚", "沈亦白", "顾清欢"],
    genres: ["都市", "情感", "社会"],
    synopsis:
      "回到故乡接手家业的女主角，与昔日好友在理想与现实之间再度交锋。剧集通过一座小城的变迁，映照出普通人面对时代浪潮的坚持与妥协。",
    poster:
      "https://readdy.ai/api/search-image?query=Serious%20artistic%20urban%20drama%20poster%20of%20a%20lone%20figure%20looking%20over%20a%20small%20town%20by%20the%20sea%20at%20dusk%2C%20muted%20deep%20blue%20and%20grey%20tones%20with%20a%20hint%20of%20dark%20red%2C%20cinematic%20dramatic%20lighting%2C%20contemplative%20mood%2C%20minimal%20composition%2C%20no%20text%2C%20high%20detail%20editorial%20photography&width=600&height=900&seq=ethics-poster-18&orientation=portrait",
    rating: 8.5,
    popularity: 92,
    updatedAt: "2024-10-06",
    releaseDate: "2024-04-19",
    runtime: "共28集",
  },
  {
    id: "silent-testimony",
    title: "无声的证词",
    year: 2022,
    type: "movie",
    region: "中国大陆",
    director: "许承梧",
    cast: ["何敬文", "梁叙", "柳未眠"],
    genres: ["犯罪", "悬疑", "社会"],
    synopsis:
      "一桩尘封多年的旧案，因为一份意外出现的证词而被重新翻开。退休警官决定在生命的最后时光里，为真相再走一程。",
    poster:
      "https://readdy.ai/api/search-image?query=Serious%20artistic%20crime%20drama%20poster%20of%20an%20old%20case%20file%20on%20a%20desk%20under%20a%20cold%20lamp%2C%20muted%20deep%20blue%20and%20grey%20tones%20with%20a%20hint%20of%20dark%20red%2C%20cinematic%20dramatic%20lighting%2C%20somber%20mood%2C%20minimal%20composition%2C%20no%20text%2C%20high%20detail%20editorial%20photography&width=600&height=900&seq=ethics-poster-19&orientation=portrait",
    rating: 8.0,
    popularity: 80,
    updatedAt: "2024-01-30",
    releaseDate: "2022-10-07",
    runtime: "126分钟",
  },
  {
    id: "between-us",
    title: "你我之间",
    year: 2023,
    type: "movie",
    region: "中国台湾",
    director: "郑柏舟",
    cast: ["许亦柔", "江书宁", "林知遥"],
    genres: ["情感", "文艺", "都市"],
    synopsis:
      "两个在同一栋楼里住了多年却素未相识的人，因为一场意外开始有了交集。影片以温柔克制的笔调，讲述孤独与靠近之间的微妙距离。",
    poster:
      "https://readdy.ai/api/search-image?query=Serious%20artistic%20romantic%20drama%20poster%20of%20two%20figures%20on%20opposite%20balconies%20of%20an%20apartment%20at%20night%2C%20muted%20deep%20blue%20and%20grey%20tones%20with%20a%20hint%20of%20dark%20red%2C%20cinematic%20dramatic%20lighting%2C%20gentle%20mood%2C%20minimal%20composition%2C%20no%20text%2C%20high%20detail%20editorial%20photography&width=600&height=900&seq=ethics-poster-20&orientation=portrait",
    rating: 8.1,
    popularity: 76,
    updatedAt: "2024-05-05",
    releaseDate: "2023-07-21",
    runtime: "112分钟",
  },
  {
    id: "the-price-of-silence",
    title: "沉默的代价",
    year: 2024,
    type: "short",
    region: "韩国",
    director: "朴叙延",
    cast: ["崔敏贞", "李道河"],
    genres: ["社会", "剧情", "悬疑"],
    synopsis:
      "一位职场新人面对上司的施压，在说出真相和保住工作之间艰难抉择。短片以紧凑的叙事，呈现个体在权力结构下的无力与勇气。",
    poster:
      "https://readdy.ai/api/search-image?query=Serious%20artistic%20workplace%20drama%20short%20poster%20of%20a%20person%20standing%20alone%20in%20a%20vast%20empty%20office%20after%20hours%2C%20muted%20deep%20blue%20and%20grey%20tones%20with%20a%20hint%20of%20dark%20red%2C%20cinematic%20dramatic%20lighting%2C%20lonely%20mood%2C%20minimal%20composition%2C%20no%20text%2C%20high%20detail%20editorial%20photography&width=600&height=900&seq=ethics-poster-21&orientation=portrait",
    rating: 7.9,
    popularity: 67,
    updatedAt: "2024-09-25",
    releaseDate: "2024-07-05",
    runtime: "30分钟",
  },
  {
    id: "the-return-road",
    title: "归途",
    year: 2022,
    type: "movie",
    region: "中国大陆",
    director: "陈砚舟",
    cast: ["周慕川", "顾清欢", "苏世安"],
    genres: ["家庭", "文艺", "剧情"],
    synopsis:
      "一位在外漂泊多年的游子，在父亲病重时踏上归途。一路上他重新走过少年时代的街道，也重新认识了那个沉默寡言的父亲。",
    poster:
      "https://readdy.ai/api/search-image?query=Serious%20artistic%20road%20drama%20poster%20of%20a%20lone%20traveler%20on%20an%20empty%20rural%20road%20at%20golden%20dusk%2C%20muted%20deep%20blue%20and%20grey%20tones%20with%20a%20hint%20of%20dark%20red%2C%20cinematic%20dramatic%20lighting%2C%20yearning%20mood%2C%20minimal%20composition%2C%20no%20text%2C%20high%20detail%20editorial%20photography&width=600&height=900&seq=ethics-poster-22&orientation=portrait",
    rating: 8.4,
    popularity: 86,
    updatedAt: "2023-12-12",
    releaseDate: "2022-05-13",
    runtime: "123分钟",
  },
  {
    id: "late-bloom",
    title: "迟开的花",
    year: 2024,
    type: "tv",
    region: "日本",
    director: "中村理沙",
    cast: ["藤井遥", "金秀妍", "梁叙"],
    genres: ["情感", "都市", "家庭"],
    synopsis:
      "三个在不同人生阶段感到迷茫的女性，因为一间小小的花店而相遇。她们彼此扶持，也各自找到了迟来的勇气与方向。",
    poster:
      "https://readdy.ai/api/search-image?query=Serious%20artistic%20ensemble%20drama%20poster%20of%20three%20women%20in%20a%20small%20flower%20shop%20at%20dusk%2C%20muted%20deep%20blue%20and%20grey%20tones%20with%20a%20hint%20of%20dark%20red%2C%20cinematic%20dramatic%20lighting%2C%20warm%20melancholic%20mood%2C%20minimal%20composition%2C%20no%20text%2C%20high%20detail%20editorial%20photography&width=600&height=900&seq=ethics-poster-23&orientation=portrait",
    rating: 8.6,
    popularity: 90,
    updatedAt: "2024-10-11",
    releaseDate: "2024-09-06",
    runtime: "共20集",
  },
  {
    id: "the-final-frame",
    title: "最后一格",
    year: 2023,
    type: "short",
    region: "中国大陆",
    director: "叶南乔",
    cast: ["沈亦白", "麦芷晴"],
    genres: ["文艺", "剧情", "情感"],
    synopsis:
      "一位老放映员在电影院关门前的最后一晚，决定为仅剩的一位观众放完最后一格胶片。短片献给所有守候在暗处的人，以及不肯熄灭的光。",
    poster:
      "https://readdy.ai/api/search-image?query=Serious%20artistic%20short%20film%20poster%20of%20an%20old%20projector%20casting%20light%20in%20an%20empty%20dim%20cinema%2C%20muted%20deep%20blue%20and%20grey%20tones%20with%20a%20hint%20of%20dark%20red%2C%20cinematic%20dramatic%20lighting%2C%20nostalgic%20mood%2C%20minimal%20composition%2C%20no%20text%2C%20high%20detail%20editorial%20photography&width=600&height=900&seq=ethics-poster-24&orientation=portrait",
    rating: 8.2,
    popularity: 70,
    updatedAt: "2024-04-20",
    releaseDate: "2023-06-09",
    runtime: "26分钟",
  },
];

export const filmTypes = [
  { key: "movie", label: "电影" },
  { key: "tv", label: "电视剧" },
  { key: "short", label: "短片" },
];

export const filmRegions = [
  "中国大陆",
  "中国香港",
  "中国台湾",
  "日本",
  "韩国",
  "欧美",
  "其他",
];

export const filmGenres = [
  "家庭",
  "婚姻",
  "都市",
  "悬疑",
  "剧情",
  "情感",
  "社会",
  "犯罪",
  "文艺",
  "商战",
];